import { createRoute } from '@/utils/routing'

export const SUBSCRIPTION_SETUP_ROUTE = 'subscription-setup'

export function createSubscriptionSetupRoute (options = {}) {
  return createRoute(SUBSCRIPTION_SETUP_ROUTE, options)
}
